import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipuriTaxeNedebitateComponent } from './tipuri-taxe-nedebitate.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditTipuriTaxeNedebitateComponent } from './edit-tipuri-taxe-nedebitate/edit-tipuri-taxe-nedebitate.component';

@NgModule({
  declarations: [
    TipuriTaxeNedebitateComponent,
    EditTipuriTaxeNedebitateComponent,
  ],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
  exports: [TipuriTaxeNedebitateComponent],
})
export class TipuriTaxeNedebitateModule {}
